import { NavLink, Outlet } from "react-router-dom";
import { useLearning } from "../learning/learning-context";

export function AppShell() {
  const { projection } = useLearning();
  const strongCount = Object.values(projection?.concepts ?? {}).filter(
    (concept) => concept.visibleState === "strong" || concept.visibleState === "remembered",
  ).length;

  return (
    <div className="app-shell">
      <header className="app-header">
        <NavLink to="/atlas" className="brand-link" aria-label="Seeing Maths Atlas">
          <span className="brand-mark" aria-hidden="true">
            ✦
          </span>
          <span>Seeing Maths</span>
        </NavLink>
        <nav className="app-nav" aria-label="Main navigation">
          <NavLink to="/atlas">Atlas</NavLink>
          <NavLink to="/fieldbook">Fieldbook</NavLink>
          <NavLink to="/account">Local profile</NavLink>
        </nav>
        <span className="artifact-count" aria-label={`${strongCount} mapped journeys`}>
          <span aria-hidden="true">✦</span> {strongCount} mapped
        </span>
      </header>
      <Outlet />
    </div>
  );
}
